module.exports = __webpack_public_path__ + "img/modal-bg-student-explain.8d0a805b.png";